const FormField = require('./form-field/')
const BinaryParser = require('mongo-binary-parser')

class Form {
  constructor(document) {
    document = document || {}
    this.id = BinaryParser.BinaryToGUID(document.id)
    this.domain = document.domain || 1
    this.name = document.name || ''
    this.description = document.description || ''
    this.isDefault = document.isDefault || false
    this.fields = (document.fields && document.fields.length) ? document.fields.map(f => new FormField(f)) : []
    this.smartFormEvents = document.smartFormEvents || []
  }
}

module.exports = Form
